import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from '../Services/user';
import { AuthService } from '../Services/auth';
import { AlertService } from '../Services/alert';
import { User } from '../Models/user';


@Component({
  selector: 'profile-password',
  templateUrl: '../Templates/profile.password.html',
})


/**
 * Register user. If there is a temporary user active, use that one to
 * register with.
 */
export class ProfilePasswordComponent {

  pwd: any; //Array<[index:string]:string>;
  user: User;

  // Form submitted?
  submitted = false;

  constructor(private userService: UserService,
              private router: Router,
              private msg: AlertService,
              private auth: AuthService) {}

  ngOnInit() {

    this.auth.getUser().subscribe(
      user => {
        if (user) {
          this.user = user;
        }
      }
    );

    this.pwd = {'new_password1': '', 'new_password2': ''};
  }

  checkPwd(pwd1, pwd2): boolean {

    if ((pwd1.dirty || pwd1.touched) && (pwd2.dirty || pwd2.touched)) {
      return (this.pwd.new_password1 == this.pwd.new_password2);
    } else {
      return true;
    }
  }

  /**
   * Reset user pwd.
   */
  resetPwd(): void {

    if (this.submitted) {
      this.msg.error("Form already submitted");
      return;
    }

    this.submitted = true;

    this.userService.resetPwd(this.user, this.pwd).subscribe(
      user => {this.user = user;
               this.msg.success("Password has been reset");
              },
      (err: HttpErrorResponse) => {

        if (err.error) {
          if (err.error.non_field_errors) {
            this.msg.error(err.error.non_field_errors);
          } else
            this.msg.error(err.error);
        } else {
          this.msg.error("Something went wrong...");
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/profile.password.ts